import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { EditAddLinkedTemplatePopupComponent } from '../linked-templates/edit-add-linked-template-popup/edit-add-linked-template-popup.component';
import { Observable, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DocumentService } from '@app/shared/services';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'location-linked-templates',
  templateUrl: './location-linked-templates.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationLinkedTemplatesComponent implements OnInit, OnDestroy {
  @ViewChildren(EditAddLinkedTemplatePopupComponent) editAddLinkedTemplatePopupComponents: QueryList<EditAddLinkedTemplatePopupComponent>;
  @Input() currentuserId;
  @Input() origin;
  @Input() currentFormId;
  @Input() isRemoveEditSaveSharing;
  @Input() formsList = [];
  @Input() data;
  @Input() enable_physical_location = false;
  @Input() has_item_location = false;
  @Output() itmeSetMark = new EventEmitter<any>();
  @Output() locationLinkedTemplateSelectionChange = new EventEmitter<{
    template: any;
    index: number;
    isChecked: boolean;
    locationType: string;
  }>();
  @Input() formName = '';
  @Input() hideManageButton = false;
  linked_recordsList = [];
  currentForm;
  form_id;
  subscription = new Subscription();

  constructor(private cd: ChangeDetectorRef, private dialog: MatDialog, private _documentService: DocumentService) {}

  ngOnInit(): void {
    this.form_id = this.data?.fid ? this.data.fid : this.data.form_id ? this.data.form_id : this.data.vault_form_id;
    this.currentForm = this.formsList.find((x) => x.id == this.form_id);
    let recommended_locations_list = [];
    try {
      let recommended_locations = this.enable_physical_location
        ? this.currentForm.recommended_password_locations
        : this.currentForm.recommended_locations;
      recommended_locations_list = recommended_locations.length ? recommended_locations.split(',') : [];

      recommended_locations_list = recommended_locations_list.map((x) => x.trim());
    } catch (error) {
      recommended_locations_list = [];
    }

    recommended_locations_list = recommended_locations_list.map((x) => {
      return {
        templateType: x,
      };
    });
    if (this.has_item_location) {
      const type_templateArray = this.currentForm.type_template.split(',');
      type_templateArray.forEach((element) => {
        if (element.toLocaleLowerCase().includes('password location') || element.toLocaleLowerCase().includes('physical location')) {
          let label = element.toLocaleLowerCase().includes('password location') ? 'Passwords In This Location' : 'Items In This Location';
          this.linked_recordsList.push({
            icon_path: 'https://s3.amazonaws.com/kinnect.app.assets/sections/locations.svg',
            is_running: false,
            label: label,
            suggestion_icon_pth: 'assets/images/linked-folder/linked-suggestion.svg',
            template_list: recommended_locations_list,
            type: element,
            allowedOne: false,
            getLinkedLocation: true,
            linkedLocation: true,
            swapFormIDWIthAssociate: true,
            type_template: element,
          });
        }
      });
    } else {
      if (this.enable_physical_location) {
        this.linked_recordsList.push({
          icon_path: 'https://s3.amazonaws.com/kinnect.app.assets/sections/locations.svg',
          is_running: false,
          label: 'Password Location',
          suggestion_icon_pth: 'assets/images/linked-folder/linked-suggestion.svg',
          template_list: recommended_locations_list,
          type: 'Password Location',
          linkedLocation: false,
          getLinkedLocation: true,
          allowedOne: false,
          type_template: 'Password Locations',
          filter_with: 'type_template',
        });
      } else {
        this.linked_recordsList.push({
          icon_path: 'https://s3.amazonaws.com/kinnect.app.assets/sections/locations.svg',
          is_running: false,
          label: 'Physical Location',
          suggestion_icon_pth: 'assets/images/linked-folder/linked-suggestion.svg',
          template_list: recommended_locations_list,
          type: 'Physical Location',
          allowedOne: true,
          filter_with: 'type_template',
          getLinkedLocation: true,
          linkedLocation: false,
          type_template: 'Physical Locations',
        });
      }
    }
  }
  openPopFromList(item) {
    this.updateLinkedTemplate(this.linked_recordsList[0]);
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  manageTemplate(event) {
    this.updateLinkedTemplate(event);
  }

  updateLinkedTemplate(item) {
    item.is_running = true;
    this.cd.detectChanges();
    const dialogRef = this.dialog.open(EditAddLinkedTemplatePopupComponent, {
      data: {
        ...item,
        currentuserId: this.currentuserId,
        formsList: this.formsList,
        formName: this.formName,
        currentFormId: this.currentFormId,
        origin: 'vault',
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        this.itmeSetMark.emit({
          ...res,
        });
        setTimeout(() => {
          item.is_running = false;
          this.cd.detectChanges();
        }, 1000);
        this.cd.detectChanges();
      })
    );
  }

  processData(item) {
    return {
      ...item,
      currentuserId: this.currentuserId,
      formsList: this.formsList,
      formName: this.formName,
      currentFormId: this.currentFormId,
      origin: 'vault',
    };
  }

  onLocationLinkedTemplateSelectionChange(event: { template: any; index: number; isChecked: boolean }) {
    const locationType = this.linked_recordsList[0]?.type || this.linked_recordsList[0]?.type_template || '';
    this.locationLinkedTemplateSelectionChange.emit({
      ...event,
      locationType,
    });
    this.cd.detectChanges();
  }

  clearSelections() {
    if (this.editAddLinkedTemplatePopupComponents) {
      this.editAddLinkedTemplatePopupComponents.forEach(component => {
        component.clearSelections();
      });
    }
    this.cd.detectChanges();
  }

  deleteTemplateObservable(template: any) {
    const componentWithTemplate = this.findComponentWithTemplate(template);
    if (componentWithTemplate) {
      return componentWithTemplate.deleteTemplateObservable(template);
    }
    return new Observable((observer) => {
      observer.next(null);
      observer.complete();
    });
  }

  findComponentWithTemplate(template: any): EditAddLinkedTemplatePopupComponent | null {
    if (!this.editAddLinkedTemplatePopupComponents || this.editAddLinkedTemplatePopupComponents.length === 0) {
      return null;
    }
    return this.editAddLinkedTemplatePopupComponents.find((component) => {
      return component.linkedTemplate?.some((t) => 
        (t.id === template.id) || 
        (t.vault_user_form_id === template.vault_user_form_id) ||
        (t.linked_form_id === template.linked_form_id && t.linked_form_id) ||
        (t.formid === template.formid && t.formid)
      );
    }) || null;
  }
}
